export default {
  computed: {
    surveyIsEdit() {
      return this.$store.getters.surveyIsEdit;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    hideCompany() {
      if (this.isSuperAdmin) {
        return false;
      }
      return true;
    },
    hideAllFilters() {
      return (
        this.filterDisplay.hideCompany &&
        this.filterDisplay.hideRegion &&
        this.filterDisplay.hideBranch &&
        this.filterDisplay.hideDevice &&
        this.filterDisplay.hidePromotionalInfo &&
        this.filterDisplay.hideDate
      );
    },
    currentUser() {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    goTo: function(route) {
      this.$router.push(route);
    },
    shown(item) {
      if (item.company && item.region && item.branch && item.device) {
        return `${item.company.name} > ${item.region.name} > ${item.branch.name} > ${item.device.name}`;
      } else if (item.company && item.region && item.branch && !item.device) {
        return `${item.company.name} > ${item.region.name} > ${item.branch.name}`;
      } else if (item.company && item.region && !item.branch && !item.device) {
        return `${item.company.name} > ${item.region.name}`;
      } else if (item.company && !item.region && !item.branch && !item.device) {
        return `${item.company.name}`;
      }
      return "";
    },
    prepareDate(dt) {
      if (dt !== null && dt !== undefined) {
        if (typeof dt === "string") {
          dt = new Date(dt);
        }
        dt.setHours(0, 0, 0, 0);
      }
      return dt;
    },
    noExpiry(item) {
      item.expiryDate = null;
    },
    noStart(item) {
      item.startDate = null;
    },
    conversion(item) {
      if (item.impressions && item.clicks) {
        let rate = (item.clicks / item.impressions) * 100;
        return Math.floor(rate);
      }
      return 0;
    },
    showToast: function(message, type) {
      this.$toasted.show(message, {
        type: type,
        duration: 3000
      });
    }
  }
};
